<template>
  <div class="key-finding-card">
    <div class="kf-label">{{ title }}：</div>
    <div class="kf-list">
      <div v-for="(item, idx) in parsedItems" :key="idx" class="kf-item">
        <span class="kf-dot">·</span>
        <span class="kf-text">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyFinding',
  props: {
    title: { type: String, default: '关键发现' },
    items: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedItems() {
      if (Array.isArray(this.items)) return this.items
      if (typeof this.items === 'string') {
        try {
          const parsed = JSON.parse(this.items)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.key-finding-card {
  max-width: 800px;
  display: flex;
  gap: 8px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #4A5FF3;
  border-radius: 8px;
}

.kf-label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #4A5FF3;
  line-height: 1.7;
}

.kf-list {
  flex: 1;
  min-width: 0;
}

.kf-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #374151;
  line-height: 1.7;
  margin-bottom: 2px;

  &:last-child {
    margin-bottom: 0;
  }
}

.kf-dot {
  flex-shrink: 0;
  color: #9ca3af;
  font-size: 12px;
  line-height: 1.7;
}

.kf-text {
  flex: 1;
}
</style>
